import { render, staticRenderFns } from "./InputGalery.vue?vue&type=template&id=3c03e21a&"
import script from "./InputGalery.vue?vue&type=script&lang=js&"
export * from "./InputGalery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports